import React from 'react';
import EmptySensogram from '../../../assets/images/products/empty-sensogram.png';
function NoSummaryChart() {
    return (<div className="product__radar-chart product__radar-chart--empty">
        <img src={EmptySensogram} alt="sensogram" />
    </div>)
};

export default NoSummaryChart;